<template>
  <div class="column" ref="form">
    <section>
      <b-field label="Che gioco è?">
        <b-input
          ref="input1"
          v-model="rawgName"
          required
          validation-message="Scrivi qualcosa!"
          @keyup.native.enter="doOkRawg"
        ></b-input>
      </b-field>
    </section>
    <section>
      <div class="buttons">
        <b-button @click="doOkRawg" type="is-primary">Vai</b-button></div>
        <div v-if="megaCount>0">Ho trovato la bellezza di {{megaCount}} giochi
      </div>

    </section>
    <section>
      <div style="cursor: pointer">
          
        <b-table
          :data="rawgData"
          :columns="rawgColumns"
          :striped="true"
          :paginated="true"
          :per-page="10"
          :total="total"
          :current-page.sync="page"
          :pagination-simple="false"
          :selected.sync="selected"
          @click="rawgClicked"
        />
      </div>
    </section>
  </div>
</template>

<script>
import api from "../api/api.js";
import helpers from "../helpers.js";

let emptyVal = { id: 0, Dicks: 0 };

export default {
  name: "AddGame",
  methods: {
    buildData(data) {
      data.forEach((row)=>{
        if (row.short_screenshots.length > 0) {
          row.screenshot = `<img src="${row.short_screenshots[0].image}" width="100px" height="100px">`
        }
        else
        row.screenshot = `<img src="${row.background_image}" width="100px" height="100px">`
      })
      return data;
    },
    isoDate(date) {
      return helpers.buildIsoDate(date);
    },
    doOkRawg() {
      const loading = this.$buefy.loading.open();
      api.game.search(this.rawgName).then((data) => {
        this.megaCount = data.data.count;
        this.rawgData = this.buildData(data.data.results);
        loading.close();
      })
      .catch(() => {
        helpers.error("Urca, qualcosa è andato male nella ricerca");
          loading.close();
      });
    },
    rawgClicked(row) {
      // const loading = this.$buefy.loading.open();
      // api.series.getTmdb(row.id)
      //   .then((data) => {
      //     loading.close();
          let game =row;
          this.$emit("OkSearchRawg", game);
        // })
        // .catch(() => {
        //   loading.close();
        // });
    },
  },
  data() {
    return {
      selectedRow: null,
      newItem: emptyVal,
      vShow: {},
      rowData: [],
      rawgData: [],
      rawgName: "", 
      selected: null,
      lovs: {},
      insertQueue: "Insert",
      selectedTab: 0,
      imdbName: "",
      megaCount: 0,
      page: 1,
      perPage: 10,
      total: 0,
      filter: {},
      rawgColumns: [
        {
          field: "url",
          label: "",
        },
        {
          field: "name",
          label: "Titolo",
        },
        {
          field: "released",
          label: "Data rilascio",
        },
        {
          field: "metacritic",
          label: "Metacritic",
        },
        { 
          field: "reviews_count",
          label: "# Recensioni"
        },
        {
          field:"screenshot",
          label:"Screenshot"
        },
        {
          field: "id",
          visible: false,
        }
      ],
    };
  },
  mounted() {},
};
</script>

<style>
</style>
